var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "#A9CF3D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19455_13708",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 17,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19455_13708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 35.1243C26.0278 35.1243 25.1172 34.9396 24.2681 34.5702C23.419 34.2007 22.6801 33.7016 22.0515 33.0729C21.4227 32.4443 20.9236 31.7054 20.5542 30.8562C20.1847 30.0072 20 29.0966 20 28.1243C20 27.9118 20.0715 27.7337 20.2144 27.59C20.3573 27.4462 20.5344 27.3743 20.7456 27.3743C20.9569 27.3743 21.1354 27.4462 21.2812 27.59C21.4271 27.7337 21.5 27.9118 21.5 28.1243C21.5 29.6382 22.0382 30.9334 23.1146 32.0098C24.191 33.0862 25.4861 33.6243 27 33.6243C28.5139 33.6243 29.809 33.0862 30.8854 32.0098C31.9618 30.9334 32.5 29.6382 32.5 28.1243C32.5 26.6105 31.9618 25.3153 30.8854 24.2389C29.809 23.1625 28.5112 22.6243 26.9919 22.6243H26.875L27.4167 23.166C27.5694 23.3188 27.6458 23.4959 27.6458 23.6973C27.6458 23.8987 27.5728 24.0757 27.4267 24.2285C27.2672 24.3813 27.0868 24.4577 26.8854 24.4577C26.684 24.4577 26.5069 24.3813 26.3542 24.2285L24.5208 22.3952C24.3681 22.2474 24.2917 22.075 24.2917 21.8781C24.2917 21.6812 24.3681 21.5063 24.5208 21.3535L26.3542 19.5202C26.5069 19.3674 26.6806 19.291 26.875 19.291C27.0694 19.291 27.2464 19.3674 27.4058 19.5202C27.5519 19.673 27.625 19.85 27.625 20.0514C27.625 20.2528 27.5486 20.4299 27.3958 20.5827L26.8542 21.1243H27C27.9722 21.1243 28.8828 21.3091 29.7319 21.6785C30.581 22.048 31.3199 22.5471 31.9485 23.1758C32.5773 23.8044 33.0764 24.5433 33.4458 25.3925C33.8153 26.2415 34 27.1521 34 28.1243C34 29.0966 33.8153 30.0072 33.4458 30.8562C33.0764 31.7054 32.5773 32.4443 31.9485 33.0729C31.3199 33.7016 30.581 34.2007 29.7319 34.5702C28.8828 34.9396 27.9722 35.1243 27 35.1243Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/Reset.690c58016d6b2dc25a8d6bfd6ad34d52.svg";
export { ForwardRef as ReactComponent };